<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1233_2165)">
    <path
      d="M13.0747 3.67083C13.0747 3.07329 13.7972 2.77405 14.2197 3.19657L16.4284 5.40512L18.6371 7.61366C19.0596 8.03618 18.7604 8.75862 18.1628 8.75862H13.7454C13.375 8.75862 13.0747 8.45834 13.0747 8.08792V3.67083Z"
      fill="#3F3F3F"
    />
    <path
      d="M11.6398 2.99878V9.36033C11.6398 9.82335 12.0152 10.1987 12.4782 10.1987H18.8396V19.5584C18.8396 20.3536 18.1949 20.9983 17.3996 20.9983H6.59922C5.80391 20.9983 5.15918 20.3536 5.15918 19.5584V4.43879C5.15918 3.64352 5.80391 2.99883 6.59922 2.99883L11.6398 2.99878Z"
      fill="#3F3F3F"
    />
  </g>
  <defs>
    <clipPath id="clip0_1233_2165">
      <rect width="13.6817" height="17.9996" fill="white" transform="translate(5.15918 3.00024)" />
    </clipPath>
  </defs>
</svg>
